/** @jsxImportSource @emotion/react */
"use client";
import type { Interpolation } from "@emotion/react";
import type { ImageProps } from "@packages/framework";
import type { ThemeType } from "@packages/ui";
import { Avatar, radius, spacing, Text } from "@packages/ui";

const containerStyles: Interpolation = {
  alignItems: "center",
  display: "flex",
  gap: spacing.ms,
  justifyContent: "flex-start",
  padding: spacing.ms,
  width: spacing.full,
};

const detailStyles: Interpolation<ThemeType> = (theme: ThemeType) => ({
  color: theme.semanticColors.neutralsMedium,
});

const textStyles: Interpolation = {
  alignItems: "flex-start",
  display: "flex",
  flexDirection: "column",
  gap: spacing.t,
  justifyContent: "center",
};

const errorStyles: Interpolation<ThemeType> = (theme: ThemeType) => ({
  background: theme.semanticColors.errorLowest,
  borderRadius: radius.m,
});

export type GiftDetailProps = {
  imageSrc: ImageProps["src"];
  text: string;
  label?: string;
  detail?: string;
  variant?: "default" | "error";
};

export const GiftDetail = ({
  imageSrc,
  text,
  label,
  detail,
  variant = "default",
}: GiftDetailProps) => (
  <div css={[containerStyles, variant === "error" && errorStyles]}>
    <Avatar imgSrc={imageSrc} size={40} />
    <div css={textStyles}>
      {label && (
        <Text as={"p"} type={"detail"} size={"l"}>
          {label}
        </Text>
      )}
      <Text as={"p"} type={"body"} size={"m"}>
        {text}
      </Text>
      {detail && (
        <Text as={"p"} type={"detail"} size={"m"} css={detailStyles}>
          {detail}
        </Text>
      )}
    </div>
  </div>
);
